const rotatingContentItem = (contentItem: any) => {
    return contentItem?.map((content: any) => content?.fields);
};
export {rotatingContentItem};
